import { render, staticRenderFns } from "./Tasks.vue?vue&type=template&id=71b66f90&scoped=true&"
import script from "./Tasks.vue?vue&type=script&lang=js&"
export * from "./Tasks.vue?vue&type=script&lang=js&"
import style0 from "./Tasks.vue?vue&type=style&index=0&id=71b66f90&scoped=true&lang=css&"
import style1 from "./Tasks.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b66f90",
  null
  
)

export default component.exports